import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MapPin = createReactComponent("MapPin", ["svg", defaultAttributes, [["path", {
  d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z",
  key: "gy1kji"
}], ["circle", {
  cx: "12",
  cy: "10",
  r: "3",
  key: "1byug6"
}]]]);
export default MapPin;